module.exports = __webpack_public_path__ + "assets/0238181372350d255bd842cc78f606df.png";